import { render, staticRenderFns } from "./GooglePlaystoreIcon.vue?vue&type=template&id=9c23d238"
import script from "./GooglePlaystoreIcon.vue?vue&type=script&lang=js"
export * from "./GooglePlaystoreIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports